import { ProductType } from "@app/modules/policySpace/common/policyConstants";

export class PolicySpaceConstants {
    public static Email = "Email";
    public static PolicySearchNumberOfResultsPerPage = 10;
    public static MyChangesRequestNumberOfResultsPerPage = 10;
    public static MyClaimsNumberOfResultsPerPage = 10;
    public static SuggestionValidLength = 3;
    public static SearchValidLength = 3;
    public static SuggestionsLimit = 10;
    public static NonApplicable = "N/A";
    public static PhoneNumbersDisplayLimit = 5;
}

export enum CoverageName {
    BaseAProtection = "ProtectionDeBaseA", // Chapitre A
    BaseBProtection = "ProtectionDeBaseB", // Chapitre B
    BaseProtection = "ProtectionDeBase",
}

export enum PolicySearchColumnNameHeader {
    ExpandCollapse = "expandCollapse",
    Status = "status",
    Contract = "contract",
    Proposal = "proposal",
    Owner = "owner",
    OwnerBirthDate = "ownerBirthDate",
    Insured = "insured",
    InsuredBirthDate = "insuredBirthDate",
    Agent = "agent",
    BirthDate = "birthDate",
    PhoneNumber = "phoneNumber",
    SubType = "subType",
    ActionItems = "actionItems",
}

export enum SearchPolicySortBy {
    PolicyStatus = "policyStatus",
    PolicyNumber = "policyNumber",
    ApplicationNumber = "applicationNumber",
    AgentLastName = "agentLastName",
    SubType = "subType",
}

export enum PolicySearchType {
    GeneralSearch = "generalSearch",
    PolicyNumber = "policyNumber",
    ApplicationNumber = "applicationNumber",
    Owner = "owner",
    Insured = "insured",
    NewChangeRequest = "newChangeRequest",
}

export enum UrlProductType {
    Annuity = "annuity",
    Life = "life",
    Motor = "motor",
}

export const toUrlProductType = (productTypeCode?: string): UrlProductType => {
    if (productTypeCode) {
        switch (productTypeCode) {
            case ProductType.Life:
                return UrlProductType.Life;
            case ProductType.Motor:
                return UrlProductType.Motor;
            case ProductType.Annuity:
            default:
                return UrlProductType.Annuity;
        }
    }

    return null;
};

export const toProductType = (productTypeCode?: string): ProductType => {
    if (productTypeCode) {
        switch (productTypeCode) {
            case UrlProductType.Life:
                return ProductType.Life;
            case UrlProductType.Motor:
                return ProductType.Motor;
            case UrlProductType.Annuity:
            default:
                return ProductType.Annuity;
        }
    }

    return null;
};
